import { render, staticRenderFns } from "./ImportMaterialDialog.vue?vue&type=template&id=5053aa7f&scoped=true"
import script from "./ImportMaterialDialog.vue?vue&type=script&lang=js"
export * from "./ImportMaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportMaterialDialog.vue?vue&type=style&index=0&id=5053aa7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053aa7f",
  null
  
)

export default component.exports